var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"brand-highlight-3 bg-white p-0 go-back-btn d-flex justify-content-center align-items-center",attrs:{"id":"GoBackBtn"},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fa fa-chevron-left mr-2",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v("Go back")])])
}
var staticRenderFns = []

export { render, staticRenderFns }